import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueSecurityAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-security-associate',
	path: '/secure/project/SelectProjectIssueSecurityScheme([!%]?[\\w]*).jspa',
};
